module.exports = __webpack_public_path__ + "img/icono-analitica.d812c596.svg";